import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpClient
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { CurrentUserService } from '../services/current-user.service';
import { DataService } from '../services/data.service';
@Injectable()
export class GetNotificationCountInterceptor implements HttpInterceptor {

  constructor(
    private http: HttpClient,
    private currentUserService: CurrentUserService,
    private dataService: DataService
  ) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Fire the API call in background

    const shouldRefresh = this.shouldRefreshNotificationCount(request.url);
    if (shouldRefresh) {
      this.currentUserService.currentUser.subscribe(user => {
        if (user?.id) {
          const userId = user.id;

          this.dataService.getNotificationCount(userId).subscribe((res: { count: number }) => {
            if (res) {
              this.currentUserService.setCount(res.count);
            }
          });
        }
      });
    }
    return next.handle(request);
  }
  private shouldRefreshNotificationCount(url: string): boolean {
    const isTargetedUrl =
      url.includes('api/user/profile/') ||
      url.includes('invitationbystatus');

    return isTargetedUrl;
  }
}


